import React, { useRef, useEffect, useState, useContext } from "react";
import { baseURL } from "../../utils/axios";
import * as io from "socket.io-client";
import ProfileModal from "../ProfileModal";
import { StoreContext } from "../../Context/StoreContext";
import ActivitySkeleton from "../Skeletons/ActivitySkeleton";
import Post from "./Post";
import { getPosts } from "../../actions/postActions";
import Button from "../Button";

function Activity({ roomId, isRoomBody = false }) {
  const socketRef = useRef();
  const [profileUser, setProfileUser] = useState({});
  const { state, dispatch } = useContext(StoreContext);
  const {
    post: { homePosts, isMore, offset, isMoreFetching },
    auth: { user },
  } = state;
  const updateSocketData = ({ queue_room, posts }) => {
    if (posts) {
      window.isHomeLoader = false;
      dispatch({
        type: "GET_HOME_POSTS_SUCCESS",
        payload: { posts: posts, offset: offset },
      });
    }
  };

  const openUserModal = (user) => {
    setProfileUser(user);
  };

  const closeUserModal = () => {
    setProfileUser({});
  };

  React.useEffect(() => {
    if (homePosts && homePosts.length > 0) {
      localStorage.setItem("vibehutActivity", JSON.stringify(homePosts));
    }
  }, [homePosts]);

  useEffect(() => {
    if (roomId) {
      dispatch({ type: "GET_HOME_POSTS_REQUEST" });
      socketRef.current = io.connect(`${baseURL}/room`);
      socketRef.current.on("connect", () => {
        socketRef.current.emit(
          "join-room",
          {
            roomId: roomId,
            allPost: true,
          },
          updateSocketData,
        );
      });

      socketRef.current.on("update_call", updateSocketData);
      socketRef.current.on("new_post", updateRoomFeed);
    }
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = undefined;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);
  const updateRoomFeed = ({ post }) => {
    dispatch({ type: "UPDATE_HOME_POSTS_SUCCESS", payload: post });
  };

  const handleLoadMore = () => {
    getPosts(dispatch, user?.token, isMore, offset);
  };

  return (
    <div className="h-96 pt-1 ">
      <div className="">
        {homePosts && homePosts.length !== 0 ? (
          homePosts.map((post) => {
            const startTime = post.createdAt;
            const isPrivateRoom =
              post?.roomsMentioned && post?.roomsMentioned[0]?.is_private
                ? post?.roomsMentioned[0]?.is_private
                : false;
            const isWaveRoom =
              post?.roomsMentioned && post?.roomsMentioned[0]?.isWaveRoom
                ? post?.roomsMentioned[0]?.isWaveRoom
                : false;
            if (!isPrivateRoom || (isPrivateRoom && isWaveRoom)) {
              if ((post.eventsMentioned?.length || 0) > 0) {
                for (let i = 0; i < (post.eventsMentioned?.length || 0); i++) {
                  const event = post.eventsMentioned[i];

                  if (!event.is_deleted) {
                    return (
                      <Post
                        post={post}
                        startTime={startTime}
                        key={post._id}
                        openUserModal={openUserModal}
                        isRoomBody={isRoomBody}
                      />
                    );
                  } else {
                    return "";
                  }
                }
                return "";
              } else {
                return (
                  <Post
                    post={post}
                    startTime={startTime}
                    key={post._id}
                    openUserModal={openUserModal}
                    isRoomBody={isRoomBody}
                  />
                );
              }
            } else {
              return "";
            }
          })
        ) : (
          <ActivitySkeleton />
        )}
        {!isMoreFetching ? (
          isMore && (
            <div className="flex justify-center pb-2">
              <Button
                size="vibhut-sm"
                variant="vibhut-primary"
                onClick={handleLoadMore}
              >
                Load More
              </Button>
            </div>
          )
        ) : (
          <ActivitySkeleton />
        )}
      </div>

      <ProfileModal
        isOpen={profileUser._id ? true : false}
        setIsOpen={(open) => !open && closeUserModal()}
        user={profileUser}
      />
    </div>
  );
}

export default React.memo(Activity);
